var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditSendMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 5.71429,
    fill: "#F0EFED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 26.0481C18.6231 27.2363 16.837 27.9536 14.8852 27.9536C10.5303 27.9536 7 24.3823 7 19.9768C7 15.5714 10.5303 12.0001 14.8852 12.0001C16.837 12.0001 18.6231 12.7174 20 13.9056C21.3769 12.7174 23.163 12.0001 25.1148 12.0001C29.4697 12.0001 33 15.5714 33 19.9768C33 24.3823 29.4697 27.9536 25.1148 27.9536C23.163 27.9536 21.3769 27.2363 20 26.0481Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 26.0481C21.6954 24.585 22.7705 22.4079 22.7705 19.9768C22.7705 17.5458 21.6954 15.3687 20 13.9056C21.3769 12.7174 23.163 12.0001 25.1148 12.0001C29.4697 12.0001 33 15.5714 33 19.9768C33 24.3823 29.4697 27.9536 25.1148 27.9536C23.163 27.9536 21.3769 27.2363 20 26.0481Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0001 26.0481C21.6955 24.585 22.7705 22.4079 22.7705 19.9768C22.7705 17.5458 21.6955 15.3687 20.0001 13.9056C18.3047 15.3687 17.2296 17.5458 17.2296 19.9768C17.2296 22.4079 18.3047 24.585 20.0001 26.0481Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditSendMasterCard);
export default __webpack_public_path__ + "static/media/CreditSendMasterCard.a69e68fdc759821869cda580fdea95bc.svg";
export { ForwardRef as ReactComponent };